module.exports = __webpack_public_path__ + "img/banner_02.8505da91.png";